/* istanbul ignore next */
const ACTIONS = {
    PAYOUT_DETAILS_ERROR: 'PAYOUT_DETAILS_ERROR',
    GET_BANKING_COUNTRIES: 'GET_BANKING_COUNTRIES',
    GET_BANKING_COUNTRIES_SUCCESS: 'GET_BANKING_COUNTRIES_SUCCESS',
    PAYOUT_DETAILS_FIELD_ERROR: 'PAYOUT_DETAILS_FIELD_ERROR',
    TOGGLE_PAYOUT_DETAILS_CONTINUE_BUTTON: 'TOGGLE_PAYOUT_DETAILS_CONTINUE_BUTTON',
    DISMISS_ALERT_BOX: 'DISMISS_ALERT_BOX',
    HANDLE_PAYOUT_DETAILS_FIELD_VALUE_CHANGE: 'HANDLE_PAYOUT_DETAILS_FIELD_VALUE_CHANGE',
    SUBMIT_PAYOUT_DETAILS_FORM: 'SUBMIT_PAYOUT_DETAILS_FORM',
};

/* istanbul ignore next */
const ACTION_CREATORS = {

    toggleContinueButton() {
        return {
            type: ACTIONS.TOGGLE_PAYOUT_DETAILS_CONTINUE_BUTTON
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.PAYOUT_DETAILS_ERROR,
            payload: {
                errorKey
            }
        };
    },

    setFieldError(fieldName, msg) {
        return {
            type: ACTIONS.PAYOUT_DETAILS_FIELD_ERROR,
            payload: {
                fieldName,
                msg
            }
        };
    },

    handleFieldValueChange(fieldName, fieldValue) {
        return {
            type: ACTIONS.HANDLE_PAYOUT_DETAILS_FIELD_VALUE_CHANGE,
            payload: {
                fieldName,
                fieldValue
            }
        };
    },

    dismissAlertBox() {
        return {
            type: ACTIONS.DISMISS_ALERT_BOX
        };
    },

    getBankingCountries() {
        return {
            type: ACTIONS.GET_BANKING_COUNTRIES
        };
    },

    getBankingCountriesSuccess(bankingCountries) {
        return {
            type: ACTIONS.GET_BANKING_COUNTRIES_SUCCESS,
            payload: {
                bankingCountries
            }
        };
    },

    submitPayoutDetailsForm(siteName, bankingCountryCode, bankingState, currency) {
        return {
            type: ACTIONS.SUBMIT_PAYOUT_DETAILS_FORM,
            payload: {
                siteName,
                bankingCountryCode,
                bankingState,
                currency
            }
        };
    },
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
